import { render, staticRenderFns } from "./Regular.vue?vue&type=template&id=eeef3504&lang=pug&"
import script from "./Regular.vue?vue&type=script&lang=ts&"
export * from "./Regular.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports